module.exports = __webpack_public_path__ + "static/media/zip.0a2015c1.svg";